import React from 'react';
import { FadeIn } from './FadeIn';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAward, FiBookOpen, FiTrendingUp } = FiIcons;

const stats = [
  { icon: FiAward, label: 'Jahre Erfahrung', value: '10+' },
  { icon: FiBookOpen, label: 'Seiten Praxis-Wissen', value: '200+' },
  { icon: FiTrendingUp, label: 'Cashflow-Strategien', value: '3' },
];

export const Author = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12">
        <FadeIn>
          <div className="bg-navy rounded-3xl p-8 md:p-14 shadow-2xl relative overflow-hidden">
            {/* Decorative blobs */}
            <div className="absolute top-0 right-0 w-72 h-72 bg-gold/5 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2 pointer-events-none"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-blue-500/5 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2 pointer-events-none"></div>

            <div className="relative z-10">
              {/* Label */}
              <span className="font-sans text-gold text-sm tracking-widest uppercase mb-4 block text-center">
                Über den Autor
              </span>

              {/* Monogram Avatar */}
              <div className="flex justify-center mb-8">
                <div className="w-24 h-24 rounded-full bg-gold/10 border-2 border-gold/40 flex items-center justify-center shadow-[0_0_30px_rgba(212,175,55,0.2)]">
                  <span className="font-serif text-4xl font-bold text-gold">MA</span>
                </div>
              </div>

              {/* Name & Divider */}
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-white text-center mb-4">
                Marc Arndt
              </h2>
              <div className="w-16 h-1 bg-gold mx-auto mb-10"></div>

              {/* Bio */}
              <div className="max-w-2xl mx-auto text-center mb-12">
                <p className="font-sans text-gray-300 leading-relaxed mb-4">
                  Als leidenschaftlicher Einkommens-Investor und Finanzexperte hat Marc Arndt es sich zur Aufgabe gemacht, das komplexe Thema der Börse auf das Wesentliche herunterzubrechen:{' '}
                  <strong className="text-white">Wiederkehrenden Cashflow.</strong>
                </p>
                <p className="font-sans text-gray-300 leading-relaxed">
                  Mit „Der Dividenden-Investor" teilt er seine praxiserprobten Strategien, die es ihm ermöglicht haben, sich unabhängig von Marktschwankungen ein verlässliches passives Einkommen aufzubauen.
                </p>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                {stats.map((stat, i) => (
                  <div
                    key={i}
                    className="flex flex-col items-center bg-white/5 border border-gold/15 rounded-2xl p-6 hover:bg-white/10 hover:border-gold/30 transition-all duration-300"
                  >
                    <div className="w-12 h-12 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center mb-4">
                      <SafeIcon icon={stat.icon} className="text-xl text-gold" />
                    </div>
                    <span className="font-serif text-3xl font-bold text-white mb-1">{stat.value}</span>
                    <span className="font-sans text-gray-400 text-sm text-center">{stat.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};